import { ReactNode } from 'react';
import { Flex, Heading, Text } from '@coverflex-tech/hypernova';

export const InsuranceUpgradeEducationalPoint = ({
  illustration,
  title,
  description,
}: TProps) => {
  return (
    <Flex alignItems="center" flexGrow={1} gap="md">
      <div>{illustration}</div>
      <Flex flexDirection="column">
        <Heading level={4}>{title}</Heading>
        <Text>{description}</Text>
      </Flex>
    </Flex>
  );
};

export type TProps = {
  illustration?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
};
